/**
 * FERP PDF Watermark Overlay (DRR-079)
 *
 * CSS overlay for DRAFT/CONFIDENTIAL/COPY/SAMPLE watermarks.
 * Read-only display — watermark type comes from backend document status.
 */

import { Box, Text } from '@mantine/core';
import { usePdfSuite } from './PdfSuiteContext';

export function WatermarkOverlay() {
  const { state } = usePdfSuite();
  const { watermark } = state;

  if (!watermark) return null;

  return (
    <Box
      className="pdf-watermark-overlay"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 5,
        overflow: 'hidden',
      }}
    >
      <Text
        style={{
          fontSize: '6rem',
          fontWeight: 900,
          color: 'rgba(255, 0, 0, 0.08)',
          transform: 'rotate(-35deg)',
          letterSpacing: '0.3em',
          textTransform: 'uppercase',
          userSelect: 'none',
          whiteSpace: 'nowrap',
        }}
      >
        {watermark}
      </Text>
    </Box>
  );
}
